import { PaymentMethod } from './payment-method';
import { InstallmentPlan } from './installment-plan';

export class Payment {
  amount: string;
  giftMoneyUsage: boolean;
  dcbOpen: boolean;
  paymentMethodDTO: PaymentMethod;
  installment: InstallmentPlan;
  cvv: string;
  engagementAccepted: boolean;
  creditCardAgreement: boolean;
  termsOfServiceIdCurrent: string;
}
